import { addDays, isSaturday, isSunday, isToday } from 'date-fns'
import { sortedLastIndexBy } from 'lodash'
import { IRoom } from '../models/Room'
import { IDimensions } from '../utils/Canvas'
import { colorToRGBA } from '../utils/ColorTransformator/aHexTransformer'
import { isSameDate } from '../utils/Date'
import theme from '../theme/theme'

export default (
  ctx: CanvasRenderingContext2D,
  constants: IDimensions,
  cHeight: number,
  cWidth: number,
  yOffset: number,
  xOffset: number,
  startDay: Date,
  startRoomIdx: number,
  rooms: IRoom[],
  selectedDates: Date[],
  diagonalLinesCache: HTMLCanvasElement | null,
) => {
  for (let i = -xOffset, k = 0; i < cWidth; i += constants.GRID_WIDTH, k++) {
    const day = addDays(startDay, k)
    if (isToday(day)) {
      ctx.fillStyle = theme.colors.calendar.today
      ctx.fillRect(i, 0, constants.GRID_WIDTH, cHeight)
    } else if (isSunday(day) || isSaturday(day)) {
      ctx.fillStyle = theme.colors.calendar.weekend
      ctx.fillRect(i, 0, constants.GRID_WIDTH, cHeight)
    }
  }

  ctx.fillStyle = theme.colors.calendar.gridBorder
  for (let i = -yOffset; i < cHeight; i += constants.GRID_HEIGHT) {
    if (i > 0) ctx.fillRect(0, i, cWidth, constants.GRID_BORDER_WIDTH)
  }

  for (let i = -xOffset; i < cWidth; i += constants.GRID_WIDTH) {
    if (i > 0) ctx.fillRect(i, 0, constants.GRID_BORDER_WIDTH, cHeight)
  }

  for (let i = -xOffset, k = 0; i < cWidth; i += constants.GRID_WIDTH, k++) {
    const day = addDays(startDay, k)
    const sortedDayIndex = sortedLastIndexBy(selectedDates, day, d =>
      d.getTime(),
    )
    if (
      diagonalLinesCache &&
      sortedDayIndex &&
      isSameDate(selectedDates[sortedDayIndex - 1], day)
    ) {
      ctx.drawImage(diagonalLinesCache, i, 0)
    }
  }

  for (
    let i = -yOffset, k = 0;
    i < cHeight + constants.GRID_HEIGHT && k < rooms.length;
    i += constants.GRID_HEIGHT, k++
  ) {
    const room = rooms[startRoomIdx + k]
    if (!room) break
    ctx.fillStyle =
      !room.customColor ||
      (room.customColor.hex() === '#FFFFFF' && room.customColor.alpha() === 0)
        ? 'rgba(255, 255, 255, 0.2)'
        : colorToRGBA(room.customColor, 0.2)
    ctx.fillRect(0, i, cWidth, constants.GRID_HEIGHT)
  }
}
